import * as _ from "lodash";
import {User} from "../../../models/User";
import {
    UserDashboardView,
    UserInstallView,
    UserNotificationView,
    UserProfileView,
    UserTeamView
} from "./UserDetailViews";
import {BaseAccountOverviewView} from "../_BaseAccountViews";


export class UserOverviewView extends BaseAccountOverviewView {

    private currentUserProfile: User = null;

    show(userId, detail?, subDetail?) {
        this.currentDetail = detail;

        if (!userId) {
            this.currentUserProfile = this.options.currentUser;
        } else {
            this.currentUserProfile = this.options.userCollection.findWhere({id: Number(userId)});
        }

        this.collectionLoaded = true;
        this.render();

        // If there is a detail render it exclusively
        if (detail) {
            this.renderSubViews(detail, false);
            return;
        }

        // Otherwise render all details
        _.each(['profile', 'teams', 'dashboards', 'installs', 'notifications'], (viewClass) => {
            this.renderSubViews(viewClass, true);
        });
    }

    render() {
        var userIsOrgAdmin = this.currentUserProfile ? (this.options.currentUser.isSensewareAdmin() || this.currentUserProfile.get('id') === this.options.currentUser.get('id')) : false;
        this.options.userGroupCollection.each((group) => {
            if (_.has(this.options.currentUser.get('usergroups'), String(group.get('id'))) && group.get('is_admin')) userIsOrgAdmin = true;
        }, this);

        this.$el.html(this.template({
            collectionLoaded: this.collectionLoaded,
            title: this.currentUserProfile ? this.currentUserProfile.get('name') : '',
            canView: true
        }));

        this.showBreadcrumbs();
        (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        this.delegateEvents();
        return this;
    }

    showBreadcrumbs() {
        if (!this.options.currentOrganizationId || !this.currentUserProfile) return;
        var orgId = this.options.currentOrganizationId;
        var userId = this.currentUserProfile.get('id');

        var routeString = '/#/account/' + orgId + '/users/' + userId;
        this.breadcrumbPathMap = {
            [this.currentOrganization.get('name')]: '/#/account/' + orgId,
            'Users': '/#/account/' + orgId + '/users',
        };

        var currentPath, searchByX;
        if (this.currentDetail) {
            this.breadcrumbPathMap[this.currentUserProfile.get('name')] = routeString;

            searchByX = 'User Details';
            this.breadcrumbDropDownOptions = {
                'Profile': routeString + '/profile',
                'Teams': routeString + '/teams',
                'Dashboards': routeString + '/dashboards',
                'Installs': routeString + '/installs',
                'Notifications': routeString + '/notifications',
            };
            currentPath = _.capitalize(this.currentDetail);
        } else {
            searchByX = 'User';
            currentPath = this.currentUserProfile.get('name');
            this.options.userCollection.each((u) => {
                this.breadcrumbDropDownOptions[u.get('name')] = '/#/account/' + orgId + '/users/' + u.get('id');
            });
        }

        super.showBreadcrumbs(currentPath, searchByX);
    }

    renderSubViews(detail, isOverview) {
        var options = {
            currentUserProfile: this.currentUserProfile,
            isOverview: isOverview
        };

        var subview;
        switch (detail) {
            case 'profile':
                subview = new UserProfileView(_.extend({}, this.options, options));
                break;
            case 'teams':
                subview = new UserTeamView(_.extend({}, this.options, options));
                break;
            case 'dashboards':
                subview = new UserDashboardView(_.extend({}, this.options, options));
                break;
            case 'installs':
                subview = new UserInstallView(_.extend({}, this.options, options));
                break;
            case 'notifications':
                subview = new UserNotificationView(_.extend({}, this.options, options));
                break;
        }

        if (subview) {
            this.subViews.push(subview);
            this.$('.container').append(subview.render().$el);
            subview.show();
        }
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/account/user/UserOverviewView.ts